import * as React from "react";
import { useSessionStorage } from "usehooks-ts";
import { AuthenticatedCreateJobRequestPage } from "../../CreateJobRequestPage/AuthenticatedCreateJobRequestPage/AuthenticatedCreateJobRequestPage";
import { JobRequestOrigination } from "../../../gen/clients/llts";
import { COUPA_REQUEST_ID_SESSION_STORAGE_KEY } from "../../../utils/constants";
import { useNavigation } from "../../../hooks/useNavigation";
import { ROUTES } from "../../../utils/navigationUtils";

const CreateCoupaQuotePage: React.FC = () => {
  const { navigateTo } = useNavigation();
  const [requestId, storeRequestId] = useSessionStorage(COUPA_REQUEST_ID_SESSION_STORAGE_KEY, "");

  const onSuccess = React.useCallback(() => {
    storeRequestId("");
    navigateTo(ROUTES.COUPA);
  }, [navigateTo, storeRequestId]);

  if (requestId) {
    return (
      <AuthenticatedCreateJobRequestPage
        origination={JobRequestOrigination.COUPA}
        hideSubmitForTranslation={true}
        externalReferenceId={requestId}
        onSuccess={onSuccess}
      />
    );
  }

  return <></>;
};

export { CreateCoupaQuotePage };
